<template>
  <div class="products-page">
    <!-- 顶部横幅 -->
    <section class="banner-section">
      <img src="@/assets/pic/pro-ban.jpg" alt="产品介绍" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t("products.bannerTitle") }}</h1>
        <p class="banner-subtitle">{{ $i18n.t("products.bannerDesc") }}</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="main-section">
      <div class="container">
        <!-- 区域标题 -->
        <div class="section-header scroll-animate fade-up" data-delay="0">
          <h2 class="secTitle">{{ $i18n.t("products.sectionTitle") }}</h2>
          <span>{{ $i18n.t("products.sectionSub") }}</span>
        </div>

        <!-- 业务介绍段落 -->
        <div class="content-block scroll-animate fade-up" data-delay="100">
          <p>{{ $i18n.t("products.introFull") }}</p>
        </div>

        <!-- 市场功能与结构演变 -->
        <div class="market-section scroll-animate fade-up" data-delay="200">
          <div class="market-header">
            <h3>{{ $i18n.t("products.marketTitle") }}</h3>
            <p>{{ $i18n.t("products.marketIntro") }}</p>
          </div>

          <!-- 资产增值 / 财富管理 卡片 -->
          <div class="sub-items">
            <div
              class="sub-card scroll-animate fade-up"
              :data-delay="(index + 1) * 150"
              v-for="(item, index) in marketCards"
              :key="index"
            >
              <div class="card-icon" v-html="item.icon"></div>
              <h4>{{ $i18n.t(item.titleKey) }}</h4>
              <p>{{ $i18n.t(item.descKey) }}</p>
            </div>
          </div>
        </div>

        <!-- 产品体系 -->
        <div class="system-section scroll-animate fade-up" data-delay="300">
          <div class="system-header">
            <h3>{{ $i18n.t("products.systemTitle") }}</h3>
            <p>{{ $i18n.t("products.systemIntro") }}</p>
          </div>

          <div class="category-title scroll-animate fade-up" data-delay="50">
            {{ $i18n.t("products.categoryTitle") }}
          </div>

          <!-- 三张卡片横排 -->
          <div class="category-cards">
            <div
              class="category-card scroll-animate fade-up"
              v-for="(cat, index) in categories"
              :key="index"
              :style="{ '--card-border': cat.borderColor }"
              :data-delay="(index + 1) * 150"
            >
              <div class="lineOne">
                <div class="cat-icon">
                  <span v-html="cat.icon"></span>
                </div>
                <h4>{{ $i18n.t(cat.titleKey) }}</h4>
              </div>
              <p>{{ $i18n.t(cat.descKey) }}</p>
            </div>
          </div>
        </div>

        <!-- 服务商+趋势：左文字 右图片 -->
        <div class="service-trend-grid scroll-animate fade-up" data-delay="100">
          <div class="service-trend-left">
            <div
              class="content-block service-block scroll-animate fade-up"
              data-delay="150"
            >
              <h3>{{ $i18n.t("products.serviceProviderTitle") }}</h3>
              <p>{{ $i18n.t("products.serviceProviderDesc") }}</p>
            </div>

            <div
              class="content-block trend-block scroll-animate fade-up"
              data-delay="300"
            >
              <h3>{{ $i18n.t("products.trendTitle") }}</h3>
              <p>{{ $i18n.t("products.trendDesc") }}</p>
            </div>
          </div>

          <div
            class="service-trend-right scroll-animate fade-right"
            data-delay="200"
          >
            <img
              src="@/assets/pic/futures-img3-1.jpg"
              alt="服务"
              class="trend-img"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useScrollAnimation } from "../composables/useScrollAnimation";
useScrollAnimation();

const categories = [
  {
    titleKey: "products.featStock",
    descKey: "products.featStockDesc",
    borderColor: "#22C55E",
    iconBg: "rgba(34, 197, 94, 0.08)",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M11 20C9.24404 20.0053 7.55023 19.3505 6.2545 18.1654C4.95876 16.9803 4.15575 15.3515 4.00471 13.6021C3.85368 11.8527 4.36567 10.1104 5.43913 8.72074C6.51259 7.33112 8.06911 6.3957 9.79998 6.1C15.5 5 17 4.48 19 2C20 4 21 6.18 21 10C21 15.5 16.22 20 11 20Z" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2 21C2 18 3.85 15.64 7.08 15C9.5 14.52 12 13 13 12" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
  },
  {
    titleKey: "products.featFund",
    descKey: "products.featFundDesc",
    borderColor: "#A855F7",
    iconBg: "rgba(168, 85, 247, 0.08)",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 3V21H21" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18 17V9" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13 17V5" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 17V14" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
  },
  {
    titleKey: "products.featBond",
    descKey: "products.featBondDesc",
    borderColor: "#14B8A6",
    iconBg: "rgba(20, 184, 166, 0.08)",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 22C13.8565 22 15.637 21.2625 16.9497 19.9497C18.2625 18.637 19 16.8565 19 15C19 13 18 11.1 16 9.5C14 7.9 12.5 5.5 12 3C11.5 5.5 10 7.9 8 9.5C6 11.1 5 13 5 15C5 16.8565 5.7375 18.637 7.05025 19.9497C8.36301 21.2625 10.1435 22 12 22Z" stroke="#1a3a5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
  },
];

const marketCards = [
  {
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M26.6666 17.3333C26.6666 23.9999 21.9999 27.3333 16.4533 29.2666C16.1628 29.365 15.8473 29.3603 15.5599 29.2533C9.99992 27.3333 5.33325 23.9999 5.33325 17.3333V7.99995C5.33325 7.64633 5.47373 7.30719 5.72378 7.05714C5.97383 6.80709 6.31296 6.66662 6.66659 6.66662C9.33325 6.66662 12.6666 5.06662 14.9866 3.03995C15.2691 2.79861 15.6284 2.66602 15.9999 2.66602C16.3714 2.66602 16.7308 2.79861 17.0133 3.03995C19.3466 5.07995 22.6666 6.66662 25.3333 6.66662C25.6869 6.66662 26.026 6.80709 26.2761 7.05714C26.5261 7.30719 26.6666 7.64633 26.6666 7.99995V17.3333Z" stroke="#1B4495" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    titleKey: "products.assetGrowth",
    descKey: "products.assetGrowthDesc",
  },
  {
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none"><path d="M29.6634 9.33325L18.33 20.6666L11.6634 13.9999L2.9967 22.6666" stroke="#1B4495" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"></path><path d="M21.6635 9.33325H29.6635V17.3333" stroke="#1B4495" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    titleKey: "products.wealthMgmt",
    descKey: "products.wealthMgmtDesc",
  },
];
</script>

<style scoped>
.products-page {
  min-height: 100vh;
}

/* ====== 横幅区域 ====== */
.banner-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(0, 20, 40) 0%,
    rgba(0, 20, 40, 0.78) 60%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 1;
}

.banner-img {
  width: 100%;
  /* height: 25rem; */
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 12rem;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.125rem;
}

.banner-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 31.25rem;
}

/* ====== 容器 ====== */
.container {
  max-width: 87rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

/* ====== 区域标题 - 居中+短线 ====== */
.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.secTitle {
  font-size: 1.75rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0;
}

.secTitle::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779b5;
  border-radius: 0.0625rem;
}

.section-header span {
  font-size: 1rem;
  color: #999;
  letter-spacing: 0.1875rem;
  margin-top: 0.625rem;
}

/* ====== 主内容区域 ====== */
.main-section {
  padding: 5rem 0;
  background-color: #fff;
}

/* ====== 内容块（通用） ====== */
/* .content-block {
  border-left: 0.1875rem solid #4779B5;
  padding-left: 1.875rem;
  margin-bottom: 3rem;
} */

.content-block p {
  font-size: 1.2rem;
  line-height: 2;
  color: #555;
  text-align: justify;
}

.content-block h3 {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1rem;
}

/* ====== 市场功能区域（标题居中+卡片） ====== */
.market-section {
  margin: 3rem 0;
}

.market-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.5rem;
}

.market-header h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0.75rem;
}

.market-header h3::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779b5;
  border-radius: 0.0625rem;
}

.market-header p {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
}

/* 卡片网格 */
.sub-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.sub-card {
  display: block;
  position: relative;
  overflow: hidden;
  padding: 1.875rem 1.875rem 1.875rem 1.5625rem;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),
    0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.sub-card:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.625rem 1.25rem rgba(71, 121, 181, 0.12);
}

/* 图标 */
.card-icon {
  width: 2.5rem;
  height: 2.5rem;
  background-color: rgba(27, 68, 149, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.card-icon :deep(svg) {
  width: 1.5rem;
  height: 1.5rem;
}

.sub-card h4 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.625rem;
}

.sub-card p {
  font-size: 1.1rem;
  line-height: 1.9;
  color: #666;
}

/* ====== 产品体系区域（标题居中+三卡片） ====== */
.system-section {
  margin-bottom: 3rem;
}

.system-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.system-header h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0.75rem;
}

.system-header h3::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779b5;
  border-radius: 0.0625rem;
}

.system-header p {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
}

/* 品类多元化标题 - 左对齐 */
.system-section > .category-title {
  font-size: 1.125rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1.25rem;
}

/* 三张品类卡片横排 */
.category-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.875rem;
}

.category-card {
  display: block;
  position: relative;
  overflow: hidden;
  padding: 1.5625rem 1.75rem 1.5625rem 1.5rem;
  border-radius: 0.625rem;
  border-left: 0.1875rem solid var(--card-border, #4779b5);
  background: #fff;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),
    0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.category-card:hover {
  transform: translateY(-0.1875rem);
  box-shadow: 0 0.625rem 1.25rem rgba(71, 121, 181, 0.12);
}
.lineOne {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 0.625rem;
}
/* 卡片图标 */
.cat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background-color: rgba(27, 68, 149, 0.08);
  color: #1a3a5c;
}

.cat-icon :deep(svg) {
  width: 1.5rem;
  height: 1.5rem;
}

.category-card h4 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.625rem;
}

.category-card p {
  font-size: 1.1rem;
  line-height: 1.9;
  color: #666;
}

/* ====== 服务商+趋势：左文字 右图片 ====== */
.service-trend-grid {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 3rem;
  align-items: start;
  border-radius: 0.6rem;
  background: #fff;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
}

.service-trend-left {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

/* .service-block,
.trend-block {
  border-left: 0.1875rem solid #4779B5;
  padding-left: 1.875rem;
  margin-bottom: 0;
} */

.service-block h3,
.trend-block h3 {
  font-size: 1.125rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1.1rem;
}

.service-block p,
.trend-block p {
  font-size: 1.2rem;
  line-height: 2;
  color: #555;
  text-align: justify;
}

/* 右侧图片 */
.service-trend-right {
  position: relative;
}

.trend-img {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  display: block;
}

/* ====== 响应式设计 ====== */
@media (max-width: 48rem) {
  .banner-section {
    height: 17.5rem;
  }

  .banner-img {
    /* height: 17.5rem; */
  }

  .banner-content {
    left: 1.875rem;
  }

  .banner-title {
    font-size: 1.5rem;
  }

  .banner-subtitle {
    font-size: 1rem;
  }

  .sub-items {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .category-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .service-trend-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .main-section {
    padding: 3.125rem 0;
  }
}

@media (max-width: 30rem) {
  .banner-title {
    font-size: 1.5rem;
  }
}
</style>
